// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prog[data-v-38a3a7ba]\n{\n  border: 1px solid gray;\n  padding: 0.5em;\n  margin: 0.5em;\n  cursor: pointer;\n  width: 15em;\n  height: 4em;\n}\n.prog.bg-info[data-v-38a3a7ba]\n{\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
